import React from 'react';
import { useAuthViewModel } from '../viewmodels/AuthViewModel';
import { useSidebar } from '../contexts/SidebarContext';
import { Sidebar as ModernSidebar } from './ui/Sidebar';

// 사이드바 컴포넌트
const Sidebar: React.FC = () => {
  const { logout, adminInfo } = useAuthViewModel();
  const { collapsed, toggleCollapsed } = useSidebar();

  // 로그아웃 핸들러
  const handleLogout = () => {
    console.log('🔐 Sidebar 로그아웃 시작');
    logout();
    // AuthService.logout()에서 window.location.href로 강제 리다이렉트 처리됨
  };

  return (
    <ModernSidebar
      collapsed={collapsed}
      onToggle={toggleCollapsed}
      adminInfo={adminInfo}
      onLogout={handleLogout}
    />
  );
};

export default Sidebar;